import {createApp} from 'vue'
import ModalApplication from '@/modals/components/ModalApplication'
import ModalApplicationMobile from '@/modals/components/ModalApplication'
import ModalApplicationCountryIsGuest from '@/modals/components/notification/ModalNotificationCountryIsGuest'
import store from "@/modals/store"
import router from "@/modals/router"

const app = createApp(ModalApplication)
const appMobile = createApp(ModalApplicationMobile)
const appCountryIsGuest = createApp(ModalApplicationCountryIsGuest)

/** отработает на всех router start */

/** модалка с выбором стран start */
app.use(store).use(router).mount('#vue-country-user')
appMobile.use(store).use(router).mount('#vue-country-user-mobile')
/** модалка с выбором стран end */

/** модалка для не авторизованного пользователя start */
appCountryIsGuest.use(store).mount('#vue-country-notification')
/** модалка для не авторизованного пользователя end */

/** отработает на всех router end */